import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Packages published to the public npm registry are signed to make it possible to detect if the package content has been tampered with.`}</p>
    <p>{`Signing and verifying published packages protects against an attacker controlling a registry mirror or proxy where they attempt to intercept and tamper with the package tarball content.`}</p>
    <h2>{`Migrating from PGP to ECDSA signatures`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` PGP signatures will be deprecated early 2023, in favour of ECDSA registry signatures. More information will soon be provided.`}</p>
    </Note>
    <p>{`The public npm registry is migrating away from the existing PGP signatures to ECDSA signatures that are more compact and can be verified without extra dependencies in the npm CLI.`}</p>
    <p>{`Signature verification was previously a multi-step process involving the Keybase CLI, as well as manually retrieving and parsing the signature from the package metadata.`}</p>
    <p>{`Read more about `}<a href="/verifying-registry-signatures">{`migrating and verifying signatures`}</a>{` using the npm CLI.`}</p>
    <h2>{`Supporting signatures on third-party registries`}</h2>
    <p>{`The npm CLI supports registry signatures and signing keys provided by any registry if the following conventions are followed:`}</p>
    <p><strong parentName="p">{`1. Signatures are provided in the package's `}<inlineCode parentName="strong">{`packument`}</inlineCode>{` in each published version within the `}<inlineCode parentName="strong">{`dist`}</inlineCode>{` object:`}</strong></p>
    <pre><code parentName="pre" {...{}}>{`"dist":{
  ..omitted..,
  "signatures": [{
    "keyid": "SHA256:{{SHA256_PUBLIC_KEY}}",
    "sig": "a312b9c3cb4a1b693e8ebac5ee1ca9cc01f2661c14391917dcb111517f72370809..."
  }],
`}</code></pre>
    <p>{`See this `}<a href="https://registry.npmjs.org/light-cycle/1.4.3" target="_blank">{`example of a signed package from the public npm registry`}</a>{`.`}</p>
    <p>{`To generate the signature, sign the package name, version and tarball sha integrity: `}<inlineCode parentName="p">{`\${package.name}@\${package.version}:\${package.dist.integrity}`}</inlineCode>{`.`}</p>
    <p>{`The current best practice is to use a `}<a href="https://en.wikipedia.org/wiki/Key_management#Key_management_system" target="_blank">{`Key Management System`}</a>{` that does the signing operation on a `}<a href="https://en.wikipedia.org/wiki/Hardware_security_module" target="_blank">{`Hardware Security Module (HSM)`}</a>{` in order to not directly handle the private key part, which reduces the attack surface.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`keyid`}</inlineCode>{` must match one of the public signing keys below.`}</p>
    <p><strong parentName="p">{`2. Public signing keys are provided at `}<inlineCode parentName="strong">{`registry-host.tld/-/npm/v1/keys`}</inlineCode>{` in the following format:`}</strong></p>
    <pre><code parentName="pre" {...{}}>{`{
  "keys": [{
    "expires": null,
    "keyid": "SHA256:{{SHA256_PUBLIC_KEY}}",
    "keytype": "ecdsa-sha2-nistp256",
    "scheme": "ecdsa-sha2-nistp256",
    "key": "{{B64_PUBLIC_KEY}}"
  }]
}
`}</code></pre>
    <p>{`Keys response:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`expires`}</inlineCode>{`: null or a simplified extended `}<a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank">{`ISO 8601 format`}</a>{`: `}<inlineCode parentName="li">{`YYYY-MM-DDTHH:mm:ss.sssZ`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`keydid`}</inlineCode>{`: sha256 fingerprint of the public key`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`keytype`}</inlineCode>{`: only `}<inlineCode parentName="li">{`ecdsa-sha2-nistp256`}</inlineCode>{` is currently supported by the npm CLI`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`scheme`}</inlineCode>{`: only `}<inlineCode parentName="li">{`ecdsa-sha2-nistp256`}</inlineCode>{` is currently supported by the npm CLI`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`key`}</inlineCode>{`: base64 encoded public key`}</li>
    </ul>
    <p>{`See this `}<a href="https://registry.npmjs.org/-/npm/v1/keys" target="_blank">{`example key's response from the public npm registry`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      